import React from 'react'
import PropTypes from 'prop-types'
import AceEditor from 'react-ace'
import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/theme-xcode'

const ACE_OPTIONS = {
  useWorker: false,
  showPrintMargin: false,
  showLineNumbers: true,
  highlightActiveLine: false,
  foldStyle: 'markbegin'
}

export default function AceJsonReader ({ name, value }) {
  return (
    <div className='flex-1 min-h-0 relative'>
      <AceEditor
        mode='json'
        theme='xcode'
        name={name}
        width='100%'
        height='100%'
        value={value}
        readOnly
        tabSize={2}
        editorProps={{ $blockScroll: true }}
        setOptions={ACE_OPTIONS}
      />
    </div>
  )
}

AceJsonReader.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string
}
